<template>
  <div>
    <PageHeader :schema="$schemas.customer" />
    <PageContent>
      <DynamicListPage :schema="$schemas.customer" :service="$api.customers" :slots="slotsItems">

        <template v-slot:[`subscription_status`]="{ props: { item } }">
          <span v-for="company in item.companies" :key="company.id" class="d-flex align-center py-1">
            <Chip
              :label="company.subscriptions[0].status === 'active' ? `${company.social_name}: Ativo` : `${company.social_name}: Suspenso`"
              :color="company.subscriptions[0].status === 'active' ? 'success' : 'warning'"
              small
              class="ml-2"
            />
          </span>
        </template>
      </DynamicListPage>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicListPage from '@/components/dynamics/DynamicListPage';
import { Chip } from '@/components/vuetify';

export default {
  name: 'ListCustomers',
  components: { PageHeader, PageContent, DynamicListPage, Chip },
  data: () => ({
    slotsItems: [
      { field: 'subscription_status' },
    ],
  }),
};
</script>
